// extracted by mini-css-extract-plugin
export default {"pill":"TicketRemainingTicketsStyles-module__pill___YLEJP","soldOut":"TicketRemainingTicketsStyles-module__soldOut___2u5uV"};